import { useDates } from './dates';

export function useStamp() {
  const d = useDates();
  return (at: string) => new Date(at).toLocaleDateString(d.locale, { day: 'numeric', month: 'long', year: 'numeric' });
}
